import Dialog from 'carbon-react/lib/components/dialog';
import Form from 'carbon-react/lib/components/form';
import React, { FC } from 'react';
import Button from 'carbon-react/lib/components/button';
import Typography from 'carbon-react/lib/components/typography';

import { FormattedMessage, useIntl } from '@futrli/localisation';

interface OwnProps {
  onClose: () => void;
  onSuccess: () => void;
  hasDeleteFailed: boolean;
}

export const ModalDeleteVatDeferral: FC<OwnProps> = ({ onSuccess, onClose, hasDeleteFailed }) => {
  const intl = useIntl();

  return (
    <Dialog
      open={true}
      onCancel={onClose}
      size="medium-small"
      aria-label={intl.formatMessage({
        id: 'predict.delete_vat_deferral_heading',
        defaultMessage: 'Delete deferred VAT/GST payment?'
      })}
      title={intl.formatMessage({
        id: 'predict.delete_vat_deferral_heading',
        defaultMessage: 'Delete deferred VAT/GST payment?'
      })}
    >
      <Form
        stickyFooter
        leftSideButtons={
          <Button onClick={onClose} buttonType="secondary" data-testid="dialog-actions-secondary" destructive>
            <FormattedMessage id="common.cancel" defaultMessage="Cancel" />
          </Button>
        }
        saveButton={
          <Button onClick={onSuccess} buttonType="primary" data-testid="dialog-actions-primary" destructive>
            <FormattedMessage id="common.delete" defaultMessage="Delete" />
          </Button>
        }
        onSubmit={onSuccess}
      >
        <div data-testid="dialog-content">
          <Typography fontSize="16px" mb={0}>
            <FormattedMessage
              id="predict.delete_vat_deferral_modal_content"
              defaultMessage="You can add a new deferral if you need to."
            />
          </Typography>

          {hasDeleteFailed && (
            <div className="uiTypeLabelRed">
              <FormattedMessage id="common.something_gone_wrong" defaultMessage="Whoops… Something’s gone wrong!" />
            </div>
          )}
        </div>
      </Form>
    </Dialog>
  );
};
